@if (isModalOpen) {
<app-event-information (close)="toggleModal()" [eventId]="selectedEvent!.eventId!"
                       [commandId]="selectedEvent!.commandId!">
</app-event-information>
}

<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0">
      <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pb-3 pt-2">
        <app-individual-alarms-filter class="pe-2" [numberOfResults]="numberOfAlarms"
                                      [selectedAssetTypes]="selectedAssetTypeFilters" [selectedAlarmTypes]="selectedAlarmTypes"
                                      (applied)="onDataReceived($event)">
        </app-individual-alarms-filter>

        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper pe-2">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text" (click)="toggleDatepicker()"
                   [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                   src="assets/device/x.svg" (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleDatepicker()"></div>
          <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                          [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
          }
        </div>
        <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)"></app-search>
      </div>
      <div class="row g-0 m-0 table-scroll">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ALARM_NAME" | translate }} </span>
              </th>
              <th class="col-compact">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
              </th>
              <th class="col-meter">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "STARTTIME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ENDTIME" | translate }}</span>
              </th>
              <th class="col-duration">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DURATION" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "STARTINGESTIONTIME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ENDINGESTIONTIME" | translate }}</span>
              </th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i=index">
              <td appIsNew [executedTime]="row.startSavedOnTime!" [seconds]="dayInMs"></td>
              <td class="d-flex align-items-center">
                <span class="label-box"
                      [ngStyle]="{
                                    'background-color': getAlertColor(row.alarmType),'text-decoration': (row.endEventId || row.endCommandId) ? 'line-through': 'none' }">
                  {{
                                    row.alarmType
                  }}
                </span>
              </td>
              <td class="col-compact">
                <span>{{ row.assetType }}</span>
              </td>
              <td class="col-meter">
                <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event, i)"
                      class="copyable">
                  {{ row.meterNumber }}
                  <span class="copy-tooltip"
                        *ngIf="clipboardService.copiedText === i.toString()">
                    {{
"COPIED" |
                                        translate
                    }}
                  </span>
                </span>
              </td>
              <td (click)="handleRowClick(row.startEventId!, row.startCommandId!)" style="cursor: pointer">
                <span class="d-flex align-items-center gap-2">
                  {{ row.startTime | date: "dd MMMM yyyy hh:mm a" }}
                  <i class="bi bi-box-arrow-up-right" style="color: var(--green-button); font-size: 12px;"></i>
                </span>
              </td>
              <td (click)="handleRowClick(row.endEventId!, row.endCommandId!)" style="cursor: pointer">
                <span class="d-flex align-items-center gap-2">
                  {{ row.endTime ? (row.endTime | date: "dd MMMM yyyy hh:mm a") : "/" }}
                  @if (row.endTime) {
                  <i class="bi bi-box-arrow-up-right" style="color: var(--green-button); font-size: 12px;"></i>
                  }
                </span>
              </td>
              <td class="col-duration">
                @if (row.startTime && row.endTime) {
                <span class="duration-badge">
                  <i class="bi bi-clock" style="font-size: 11px;"></i>
                  {{ getDuration(row.startTime, row.endTime) }}
                </span>
                } @else {
                <span>/</span>
                }
              </td>
              <td>
                <span>
                  {{
                                    row.startSavedOnTime | date: "dd MMMM yyyy hh:mm a"
                  }}
                </span>
              </td>
              <td>
                <span>
                  {{
                                    row.endSavedOnTime
                                    ? (row.endSavedOnTime | date: "dd MMMM yyyy hh:mm a")
                                    : "/"
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="container-down">
      <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfAlarms" [pageSize]="pageSize"
                      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
  </div>
</div>
